// <head> metadata for VideosPage (https://www.dbos.dev/videos).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'DBOS Videos',
    },
    {
      name: 'description',
      content:
        'Webcasts, demos and customer interviews on open source durable execution and workflow orchestration for Python, TypeScript, Go, Java and Kotlin.',
    },
    {
      property: 'og:title',
      content: 'DBOS Videos',
    },
    {
      property: 'og:description',
      content:
        'Webcasts, demos and customer interviews on open source durable execution and workflow orchestration for Python, TypeScript, Go, Java and Kotlin.',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/dbos-og-durable-workflows-postgres.jpg',
    },
    {
      name: 'twitter:title',
      content: 'DBOS Videos',
    },
    {
      name: 'twitter:description',
      content:
        'Webcasts, demos and customer interviews on open source durable execution and workflow orchestration for Python, TypeScript, Go, Java and Kotlin.',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/dbos-og-durable-workflows-postgres.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/videos',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
